import { Button } from '@mui/material'
import { motion } from 'motion/react'
import { BtnsHoverAnimation } from '../../utils/animation'

const MotionButton = motion.create(Button);

const OfoqThemeBtn = ({ onClick, name, dimmed, disabled, cancelStyle, customStyle, ...props }) => (
  <MotionButton
    sx={[
      styles.root,
      dimmed && styles.dimmed,
      cancelStyle ? styles.cancelStyle : styles.greenBtn, customStyle]}
      disabled={disabled}
    onClick={onClick}
    variants={BtnsHoverAnimation}
    whileHover={!disabled && 'hover'}
    {...props}>
    {name}
  </MotionButton>
)

const styles = {
  root: {
    textTransform: 'capitalize',
    fontSize: '14px',
    color: 'white',
    backgroundColor: 'primary.main',
    width: '100%',
    maxWidth: { xs: 'fit-content', md: '150px' },
    height: '40px !impotent',
    borderRadius: '10px',
    fontFamily: 'Avenir-bold',
    marginInline: '10px',
    '&:hover': {
      color: 'white',
      backgroundColor: 'primary.main',
    },
  },
  dimmed: {
    cursor: 'default',
    opacity: '0.5',

    '&:hover': {
      color: 'white',
      backgroundColor: 'primary.main',
    },
  },
  cancelStyle: {
    color: 'primary.main',
    backgroundColor: 'primary.light',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'grey.100',
    '&:hover': {
      color: 'white',
      backgroundColor: 'primary.main',
      borderColor: 'primary.main',
      boxShadow: 'none',
    },
  },
}

export default OfoqThemeBtn
